/* DemoPool free tool: streaming royalty calculator. v3 (09.10.2026): one slider, one result, platform tiles with icons.
   RATES = USD per stream, gross to the recording owner, before distributor/label cut.
   Sources + dates: stores/demopool/content/tools/royalty-calculator.md. Review by 2027-04. */
(function () {
  'use strict';
  var RATES = {
    sp: ['Spotify', 0.003, 0.005],
    am: ['Apple Music', 0.006, 0.01],
    yt: ['YouTube Music', 0.001, 0.007],
    az: ['Amazon Music', 0.004, 0.009],
    td: ['Tidal', 0.011, 0.015],
    dz: ['Deezer', 0.005, 0.007],
    sc: ['SoundCloud', 0.0025, 0.004]
  };
  var SPOTIFY_MIN = 1000; // streams per track in 12 months (Spotify for Artists, since Apr 2024)
  var MIN = 1e3, MAX = 1e7, CAP = 1e10; // slider 1K..10M (log), typed value up to CAP

  // ---------- pure helpers (exported for tests) ----------
  function parseNum(v) {
    var s = String(v == null ? '' : v).toLowerCase().replace(/[\s,$]/g, '');
    var m = s.match(/^(\d*\.?\d+)([km]?)$/);
    if (!m) return NaN;
    return parseFloat(m[1]) * (m[2] === 'k' ? 1e3 : m[2] === 'm' ? 1e6 : 1);
  }
  function clamp(n, a, b) { return Math.min(b, Math.max(a, n)); }
  function money(n) {
    if (!isFinite(n)) return '—';
    if (n > 0 && n < 0.01) return '<$0.01';
    var d = n < 10 && n !== Math.round(n) ? 2 : 0;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d });
  }
  function full(n) { return Math.round(n).toLocaleString('en-US'); }
  function calc(id, s) {
    var r = RATES[id], zero = id === 'sp' && s < SPOTIFY_MIN;
    var lo = zero ? 0 : s * r[1], hi = zero ? 0 : s * r[2];
    return { id: id, name: r[0], lo: lo, hi: hi, mid: (lo + hi) / 2, zero: zero };
  }
  // log slider 0..1000 <-> 1K..10M, rounded to 2 significant digits
  var SPAN = Math.log10(MAX / MIN);
  function fromSlider(v) { var n = MIN * Math.pow(10, (v / 1000) * SPAN), p = Math.pow(10, Math.floor(Math.log10(n)) - 1); return Math.round(n / p) * p; }
  function toSlider(n) { return Math.round(clamp(Math.log10(Math.max(n, MIN) / MIN) / SPAN, 0, 1) * 1000); }

  var api = { RATES: RATES, parseNum: parseNum, money: money, calc: calc, fromSlider: fromSlider, toSlider: toSlider };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }

  // ---------- UI ----------
  var root = document.querySelector('[data-rc]');
  if (!root) return;
  var num = root.querySelector('#rc-streams'), rng = root.querySelector('#rc-range');
  var sum = root.querySelector('#rc-sum'), sub = root.querySelector('#rc-sub'), on = root.querySelector('#rc-on');
  var btns = Array.prototype.slice.call(root.querySelectorAll('[data-p]'));
  var st = { s: 100000, p: 'sp' };

  try {
    var q = new URLSearchParams(location.search);
    var qs = parseNum(q.get('s')); if (qs >= 0) st.s = clamp(Math.round(qs), 0, CAP);
    if (RATES[q.get('p')]) st.p = q.get('p');
  } catch (err) { /* old browser: defaults */ }

  function url() { return location.origin + location.pathname + '?s=' + st.s + (st.p !== 'sp' ? '&p=' + st.p : ''); }

  var note = '';
  function render(fromRange) {
    if (document.activeElement !== num) num.value = full(st.s);
    if (!fromRange) rng.value = toSlider(st.s);
    rng.style.setProperty('--fill', (rng.value / 10) + '%');
    rng.setAttribute('aria-valuetext', full(st.s) + ' streams');

    var rows = btns.map(function (b) {
      var id = b.getAttribute('data-p'), r = calc(id, st.s);
      b.setAttribute('aria-pressed', id === st.p ? 'true' : 'false');
      b.classList.toggle('is-zero', r.zero);
      b.querySelector('[data-v]').textContent = money(r.mid);
      return r;
    });
    var m = calc(st.p, st.s);
    on.textContent = 'Approx. on ' + m.name;
    sum.textContent = '≈ ' + money(m.mid);
    root.classList.toggle('is-long', full(st.s).length > 7 || money(m.mid).length > 7);
    sub.textContent = m.zero
      ? '$0 under 1,000 streams a year'
      : money(m.lo) + '–' + money(m.hi) + ' range';

    note = 'Royalty estimate for ' + full(st.s) + ' streams: ' +
      rows.map(function (r) { return r.name + ' ' + money(r.lo) + '-' + money(r.hi); }).join('; ') + '. ' + url();
    var f = document.querySelector('[data-tool-lead] input[name="contact[note]"]');
    if (f) f.value = note.slice(0, 900);
    var off = document.querySelector('[data-offer]');
    if (off) off.setAttribute('data-lede', (m.mid > 0 ? 'Your ' + full(st.s) + ' streams pay about ' + money(m.mid) + ' on ' + m.name + '. ' : '') + 'Playlists are where most new streams come from. Pick your genre:');
    clearTimeout(render.h);
    render.h = setTimeout(function () { try { history.replaceState(null, '', url()); } catch (err) {} }, 400);
  }

  rng.addEventListener('input', function () { st.s = fromSlider(+rng.value); render(true); });
  num.addEventListener('focus', function () { num.select(); });
  num.addEventListener('input', function () { var n = parseNum(num.value); if (n >= 0) { st.s = clamp(Math.round(n), 0, CAP); render(); } });
  num.addEventListener('blur', function () { num.value = full(st.s); });
  num.addEventListener('keydown', function (e) { if (e.key === 'Enter') num.blur(); });
  btns.forEach(function (b) { b.addEventListener('click', function () { st.p = b.getAttribute('data-p'); render(); }); });

  var form = document.querySelector('[data-tool-lead] form');
  if (form) form.addEventListener('submit', function () { var f = form.querySelector('input[name="contact[note]"]'); if (f) f.value = note.slice(0, 900); });

  // methodology tooltip: hover on desktop (CSS), tap/click toggles, Esc / outside click closes
  var ti = document.querySelector('[data-tinfo]');
  if (ti) {
    var tb = ti.querySelector('button');
    var set = function (o) { ti.classList.toggle('is-open', o); tb.setAttribute('aria-expanded', o ? 'true' : 'false'); };
    tb.addEventListener('click', function (e) { e.stopPropagation(); set(!ti.classList.contains('is-open')); });
    document.addEventListener('click', function (e) { if (!ti.contains(e.target)) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  render();
})();
